import { render, staticRenderFns } from "./FulfillmentNonKomship.vue?vue&type=template&id=6faf918f&"
import script from "./FulfillmentNonKomship.vue?vue&type=script&lang=js&"
export * from "./FulfillmentNonKomship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports